import { motion } from 'framer-motion'
import { Mail, Phone, MapPin, Send, User, Building } from 'lucide-react'
import { useState } from 'react'

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: '',
    contactPerson: '' // Nouveau champ pour choisir le contact
  })

  const contactPersons = [
    {
      id: 'ouahibi',
      name: 'Ouahibi Hassan',
      function: 'Chargé du secteur Maroc-Afrique',
      phone: '0660346512',
      whatsapp: '33770100134',
      email: 'ecotherm0045@gmail.com',
      region: 'Maroc-Afrique'
    },
    {
      id: 'benhalima',
      name: 'Benhalima Samir',
      function: 'Chargé du secteur France - Europe',
      phone: '0782627968',
      whatsapp: '33782627968',
      email: 'ldstockeur@gmail.com',
      region: 'France-Europe'
    }
  ]

  const handleSubmit = (e) => {
    e.preventDefault()
    
    // Trouver le contact sélectionné
    const selectedContact = contactPersons.find(person => person.id === formData.contactPerson)
    
    if (!selectedContact) {
      alert('Veuillez sélectionner un contact')
      return
    }

    // Créer le message WhatsApp
    const whatsappMessage = `
*Nouveau message de contact - LD STOCKEUR*

*Nom:* ${formData.name}
*Email:* ${formData.email}
*Téléphone:* ${formData.phone}
*Entreprise:* ${formData.company}
*Contact sélectionné:* ${selectedContact.name}
*Région:* ${selectedContact.region}

*Message:*
${formData.message}

*Envoyé via le site ECOTHERM*
    `.trim()

    // Encoder le message pour URL
    const encodedMessage = encodeURIComponent(whatsappMessage)
    const whatsappUrl = `https://wa.me/${selectedContact.whatsapp}?text=${encodedMessage}`

    // Ouvrir WhatsApp
    window.open(whatsappUrl, '_blank')
    
    // Réinitialiser le formulaire
    setFormData({ 
      name: '', 
      email: '', 
      phone: '', 
      company: '', 
      message: '',
      contactPerson: '' 
    })
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  return (
    <div className="min-h-screen pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h1 className="text-5xl md:text-6xl font-bold text-gradient mb-6">Contactez-Nous</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Notre équipe est à votre disposition pour répondre à toutes vos questions et vous accompagner dans vos projets.
          </p>
        </motion.div>

        {/* Informations de l'entreprise */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="bg-gradient-to-r from-green-600 to-green-700 rounded-2xl p-8 text-white mb-16 text-center"
        >
          <h2 className="text-3xl font-bold mb-4">LD STOCKEUR</h2>
          <p className="text-xl mb-4">Votre partenaire pour les solutions ECOTHERM</p>
          <div className="flex items-center justify-center gap-2">
            <MapPin className="w-5 h-5" />
            <p className="text-lg">RDC Quartier MGHAYAR 2, Lot 250 - 90000 TANGER</p>
          </div>
        </motion.div>

        {/* Contacts de l'équipe */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
          {contactPersons.map((person, index) => (
            <motion.div
              key={person.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-6 shadow-lg border border-green-200"
            >
              <div className="text-center mb-4">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <User className="w-8 h-8 text-green-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900">{person.name}</h3>
                <p className="text-green-600 font-semibold">{person.function}</p>
                <p className="text-gray-500 text-sm mt-1">{person.region}</p>
              </div>
              
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-gray-700">
                  <Phone className="w-4 h-4 text-green-600" />
                  <a href={`tel:${person.phone}`} className="hover:text-green-600 transition-colors">
                    {person.phone}
                  </a>
                </div>
                <div className="flex items-center gap-2 text-gray-700">
                  <Mail className="w-4 h-4 text-green-600" />
                  <a href={`mailto:${person.email}`} className="hover:text-green-600 transition-colors text-sm">
                    {person.email}
                  </a>
                </div>
                <div className="pt-2">
                  <a 
                    href={`https://wa.me/${person.whatsapp}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition-colors flex items-center justify-center gap-2 text-sm"
                  >
                    <span>📱</span>
                    WhatsApp
                  </a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="bg-white rounded-2xl p-8 shadow-lg"
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Envoyez-nous un Message</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Nom Complet *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-green-600 focus:outline-none transition-colors"
                  placeholder="Votre nom"
                />
              </div>
              
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-green-600 focus:outline-none transition-colors"
                  placeholder="votre@email.com"
                />
              </div>
              
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Téléphone *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-green-600 focus:outline-none transition-colors"
                  placeholder="+212 XXX-XXXXXX"
                />
              </div>
              
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Entreprise</label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-green-600 focus:outline-none transition-colors"
                  placeholder="Nom de votre entreprise"
                />
              </div>

              {/* Sélection du contact */}
              <div>
                <label className="block text-gray-700 font-semibold mb-2">
                  <User className="w-4 h-4 inline mr-2" />
                  Choisir le contact *
                </label>
                <select
                  name="contactPerson"
                  value={formData.contactPerson}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-green-600 focus:outline-none transition-colors"
                >
                  <option value="">Sélectionnez un contact</option>
                  {contactPersons.map((person) => (
                    <option key={person.id} value={person.id}>
                      {person.name} - {person.region}
                    </option>
                  ))}
                </select>
              </div>
              
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Message *</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-green-600 focus:outline-none transition-colors resize-none"
                  placeholder="Décrivez votre projet ou posez vos questions..."
                ></textarea>
              </div>
              
              <button 
                type="submit" 
                className="w-full bg-green-600 text-white py-4 px-6 rounded-lg hover:bg-green-700 transition-colors font-semibold text-lg inline-flex items-center justify-center gap-3"
              >
                <span>📱</span>
                Envoyer via WhatsApp
                <Send className="w-5 h-5" />
              </button>
            </form>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="space-y-8"
          >
            <div className="bg-gradient-to-br from-green-600 to-green-700 rounded-2xl p-8 text-white">
              <h2 className="text-3xl font-bold mb-6">Horaires d'Ouverture</h2>
              <div className="space-y-4">
                <div className="flex justify-between items-center pb-4 border-b border-white border-opacity-20">
                  <span className="font-semibold">Lundi - Vendredi</span>
                  <span>9h00 - 18h00</span>
                </div>
                <div className="flex justify-between items-center pb-4 border-b border-white border-opacity-20">
                  <span className="font-semibold">Samedi</span>
                  <span>9h00 - 13h00</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="font-semibold">Dimanche</span>
                  <span>Fermé</span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Pourquoi nous contacter ?</h2>
              <p className="text-gray-600 mb-6">Notre équipe technique est disponible pour vous conseiller sur le choix et l'application de nos produits ECOTHERM.</p>
              <div className="space-y-3">
                <div className="flex items-center gap-3 text-gray-700">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-green-600">✓</span>
                  </div>
                  <span>Conseils techniques personnalisés</span>
                </div>
                <div className="flex items-center gap-3 text-gray-700">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-green-600">✓</span>
                  </div>
                  <span>Devis gratuit sous 48h</span>
                </div>
                <div className="flex items-center gap-3 text-gray-700">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-green-600">✓</span>
                  </div>
                  <span>Support après-vente</span>
                </div>
                <div className="flex items-center gap-3 text-gray-700">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-green-600">✓</span>
                  </div>
                  <span>Livraison internationale</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default Contact